
import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
    // Basically the `data` in your component but for the whole app.
    state: {
        links: [
            {
                title: 'Google',
                url: 'http://google.com',
                active: false
            },
            {
                title: 'Kiva',
                url: 'http://kiva.org',
                active: false
            }
        ],
        product_id: 0
    },
    // Basically `computed` values shared across components.
    getters: {
    },
    // Synchronous methods for modifying the values in the state.
    // They are handed a `state` from the store, and an optional `payload` value you pass in.
    mutations: {
        activateLink: function (state, payload) {
            state.links.forEach(function (link) {
                link.active = false;
            });
            state.links[payload.index].active = true;
        },
        updateProductID: function (state, payload) {
            state.product_id = payload.product_id;
        }
    },
    // Asynchronous methods that can call mutation methods to mutate the state via commits.
    // They are handed a context of the `store`, and an optional `payload` object you pass in.
    actions: {
        activateLink: function (store, payload) {
            store.commit('activateLink', payload);
        },
        updateProductID: function (store, payload) {
            store.commit('updateProductID', payload);
        }

    }
});